module.exports = __webpack_public_path__ + "img/15.7fe8ace1.png";